'use client'

import React from 'react';
import { Flex, Text } from '@chakra-ui/layout';
import { Button } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '../i18n/LanguageContext';
import { trackUmamiEvent } from '../lib/analytics/umami';
import { handleAuthRedirectClick } from '../lib/navigation/externalBrowser';

export default function HeaderMenuDesktop() {

  const location = useLocation();
  const { t } = useTranslation();

  return (
    <Flex
      as="nav"
      aria-label={t("nav.mainAria")}
      flexDirection={"row"}
      alignItems={"center"}
    >
      <Link to="/">
        <Text w="90px" textAlign={"center"} color={(
          location.pathname === '/' ? 'fill.coral' : 'text.medium.dark'
        )}>{t("nav.home")}</Text>
      </Link>
      <Link to="/features">
        <Text w="120px" textAlign={"center"} color={(
          location.pathname.includes('features') ? 'fill.coral' : 'text.medium.dark'
        )}>{t("nav.features")}</Text>
      </Link>
      <Link to="/pricing">
        <Text w="75px" textAlign={"center"} color={(
          location.pathname.includes('pricing') ? 'fill.coral' : 'text.medium.dark'
        )}>{t("nav.pricing")}</Text>
      </Link>
      <Link
        to="https://support.bibliona.com/"
        target='_blank'
        onClick={() => trackUmamiEvent("navigation_click", { location: "header_desktop", destination: "support" })}
      >
        <Text w="75px" textAlign={"center"} color={(
          location.pathname.includes('support') ? 'fill.coral' : 'text.medium.dark'
        )}>{t("nav.support")}</Text>
      </Link>
      <Link
        to={process.env.REACT_APP_BIBLIONA_URL + '/auth/sign-up'}
        target='_blank'
        onClick={() => trackUmamiEvent("cta_click", { location: "header_desktop", cta: "sign_up" })}
      >
        <Button variant="coralOutline" ml={3}>{t("nav.signUp")}</Button>
      </Link>
      <Link
        to={process.env.REACT_APP_BIBLIONA_URL}
        target="_blank"
        onClick={(event) =>
          handleAuthRedirectClick(event, process.env.REACT_APP_BIBLIONA_URL, () =>
            trackUmamiEvent("cta_click", { location: "header_desktop", cta: "sign_in" })
          )
        }
      >
        <Button variant="coralFill" ml={3}>{t("nav.signIn")}</Button>
      </Link>
    </Flex>
  );
}
